export function cloneObject(objectToClone) {
  return JSON.parse(JSON.stringify(objectToClone));
}

export function updateObjectInArray(array, objectToUpdate, conditionFn) {
  //object index of the given condition
  let elementIndex = array.findIndex((obj) => conditionFn(obj));
  // if index present the update the object in the array else do nothing
  if (elementIndex !== -1) {
    array[elementIndex] = objectToUpdate;
  }
}
